import React from "react";

import { Report } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useAllFetchedPagination } from "@/hooks/use-pagination";
import { useGpdReportListAllPagesQuery } from "@/queries/query-gpd";

export const gpdReportInformation: { key: keyof Report; label: string }[] = [
  { key: "reportId", label: "Rapport-ID" },
  { key: "method", label: "Methode" },
  { key: "beginDate", label: "Startdatum" },
  { key: "endDate", label: "Einddatum" },
  { key: "groundwaterUsageFacilityBroId", label: "GUF BRO-ID" },
];

const columnDefinitions: ColumnDefinition<Report>[] = gpdReportInformation.map(
  ({ key, label }, index) => ({
    title: label,
    renderFunction: (row) =>
      renderDefault(row[key], index === 0 ? `/gpd/rapport/${row.uuid}/` : undefined),
    width: "1fr",
  })
);

const GpdReportTable: React.FC<{ gpd: string }> = ({ gpd }) => {
  const { data, isLoading } = useGpdReportListAllPagesQuery();

  const gpdReports = (data?.results ?? [])
    .filter((report) => report.gpd === gpd)
    .sort((a, b) => a.beginDate.getTime() - b.beginDate.getTime());

  const { paginatedTableData, ...paginationProps } = useAllFetchedPagination(false, gpdReports);

  return (
    <TableOverview
      themeColor="#b9acfc"
      isLoading={isLoading}
      tableData={paginatedTableData}
      columnDefinitions={columnDefinitions}
      paginationProps={paginationProps}
    />
  );
};

export { GpdReportTable };
